<mip-contact-form
  [formConfig]="currentForm"
></mip-contact-form>
